(function () {
  const CACHE_KEY = 'cartRecommendations_v3';
  const LEGACY_KEYS = ['cartRecommendations_v2', 'cartRecommendations'];
  const TTL_MS = 10 * 60 * 1000;

  function getSessionStorage() {
    try {
      return window.sessionStorage || null;
    } catch (error) {
      return null;
    }
  }

  function getLocalStorage() {
    try {
      return window.localStorage || null;
    } catch (error) {
      return null;
    }
  }

  function getLocale() {
    return document.documentElement.lang || '';
  }

  function getCurrency() {
    return window.Shopify?.currency?.active || window.cartCurrency || '';
  }

  function getContext(cartHash) {
    return {
      cartHash: cartHash || '',
      locale: getLocale(),
      currency: getCurrency(),
    };
  }

  function readPayload() {
    const storage = getSessionStorage();
    if (!storage) return null;

    try {
      const stored = storage.getItem(CACHE_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      storage.removeItem(CACHE_KEY);
      return null;
    }
  }

  function isUsable(payload, cartHash) {
    if (!payload || !Array.isArray(payload.products)) return false;

    const context = getContext(cartHash);
    const age = Date.now() - Number(payload.createdAt || 0);

    return (
      payload.cartHash === context.cartHash &&
      payload.locale === context.locale &&
      payload.currency === context.currency &&
      age >= 0 &&
      age <= TTL_MS
    );
  }

  function writePayload(payload) {
    const storage = getSessionStorage();
    if (!storage) return;

    try {
      storage.setItem(CACHE_KEY, JSON.stringify(payload));
    } catch (error) {
      storage.removeItem(CACHE_KEY);
    }
  }

  function clearLegacyStorage() {
    const legacyStorage = getLocalStorage();
    if (!legacyStorage) return;

    LEGACY_KEYS.forEach((key) => legacyStorage.removeItem(key));
  }

  window.CartRecommendationsCache = {
    key: CACHE_KEY,
    ttlMs: TTL_MS,

    read(cartHash) {
      const payload = readPayload();
      if (!isUsable(payload, cartHash)) {
        this.clear();
        return [];
      }

      return payload.products;
    },

    write(cartHash, products) {
      if (!cartHash || !Array.isArray(products)) {
        this.clear();
        return;
      }

      writePayload({
        ...getContext(cartHash),
        createdAt: Date.now(),
        products,
      });
      clearLegacyStorage();
    },

    removeVariant(variantId) {
      const payload = readPayload();
      if (!payload || !Array.isArray(payload.products)) return;

      const id = Number(variantId);
      payload.products = payload.products.filter(
        (product) => !(product.variants || []).some((variant) => Number(variant.id) === id)
      );
      payload.createdAt = Date.now();

      if (payload.products.length) {
        writePayload(payload);
      } else {
        this.clear();
      }
    },

    clear() {
      const storage = getSessionStorage();
      if (storage) storage.removeItem(CACHE_KEY);
      clearLegacyStorage();
    },
  };
})();
